import {MenuOutlined, ZoomInOutlined} from '@ant-design/icons'
import {Button, Col, Form, Input, Layout, PageHeader, Row, Table, Tag} from 'antd'
import {ColumnsType} from 'antd/lib/table/interface'
import * as React from 'react'
import {useState} from 'react'
import {useQuery} from 'react-query'
import {renderRoutes, RouteConfigComponentProps} from 'react-router-config'
import {Link, useHistory} from 'react-router-dom'
import {useRecoilState} from 'recoil'
import {menuCollapseState} from '../../../state/atoms'
import {dateTimeFormat} from '../../../utils/formatters'
import {ATTENDANCE_STATUS_MP} from '../../constants'
import {qs} from '../../queries'
import {AttendanceModel} from '../../typings'

const queryString = require('query-string')

const AdvancedSearchForm = React.memo(({ setQsQuery, refetch }: { setQsQuery: (data: any) => void, refetch: () => void }) => {
  const [filterForm] = Form.useForm()

  const onFinish = (values: any) => {
    let __qs = queryString.stringify(values, { arrayFormat: 'comma' })

    setQsQuery(__qs)
    setQsQuery(__qs)

    refetch()
  }

  return (
    <Form
      form={filterForm}
      name="advanced_search"
      className="advanced-search-form"
      onFinish={onFinish}
      layout={'vertical'}
    >
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item name={`filter{patient.name.icontains}`} label={`Paciente`}>
            <Input/>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name={`filter{doctor.name.icontains}`} label={`Doutor`}>
            <Input/>
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button type="primary" htmlType="submit">
            Filtrar
          </Button>
          <Button
            style={{ margin: '0 8px' }}
            onClick={() => {
              filterForm.resetFields()
              setQsQuery('')
              setQsQuery('')
              refetch()
            }}
          >
            Resetar filtro
          </Button>
        </Col>
      </Row>
    </Form>
  )
})

type Props = RouteConfigComponentProps

const status_color_map = {
  'PENDENT': 'orange',
  'FINISHED': 'green',
  'CONFIRMED': 'cyan',
  'CANCELED': 'red'
}

export const AttendanceListPage: React.FC<Props> = (props) => {
  const [qs_query, setQsQuery] = useState('')
  const { isFetching, data, refetch } = useQuery('getAttendances', () => qs.attendances.all(qs_query))
  const history = useHistory()
  const [collapsed, setCollapsed] = useRecoilState(menuCollapseState)

  const grid_columns: ColumnsType<AttendanceModel> = [
    {
      title: 'Paciente',
      width: 100,
      dataIndex: 'patient_name'
    },
    {
      title: 'Doutor',
      width: 120,
      dataIndex: 'doctor_name'
    },
    {
      title: 'Data',
      dataIndex: 'date_start',
      width: 60,
      render: (value) => dateTimeFormat(value)
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: 60,
      render: (value) => <Tag color={status_color_map[value]}>{ATTENDANCE_STATUS_MP[value]}</Tag>
    },
    {
      title: 'Ações',
      dataIndex: 'id',
      align: 'right',
      width: 20,
      render: (value) => (
        <Link to={`/attendances-list/${value}`}><ZoomInOutlined style={{ fontSize: '16px', marginRight: 5 }}/></Link>
      )
    }
  ]

  return (
    <React.Fragment>
      <PageHeader
        ghost={false}
        title={'Atendimentos'}
        onBack={() => setCollapsed(!collapsed)}
        backIcon={<MenuOutlined/>}
      />

      <AdvancedSearchForm refetch={refetch} setQsQuery={setQsQuery}/>

      <Layout.Content className="body-container">
        <Button type="primary" onClick={() => history.push('/attendances/new')}>Novo</Button>
        <Table columns={grid_columns} dataSource={data} rowKey="id" loading={isFetching}/>
        {renderRoutes(props.route?.routes)}
      </Layout.Content>
    </React.Fragment>
  )
}
